<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="htitle">
<br class="calibre1"/><br class="calibre1"/>
<p class="bkht">Sorrow Without End</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-sorrowend0001_split_001.vue?0a2c1623